/* Native Gardeners accessibility enhancements, round 8 (November 4, 2026).
   Loads after a11y-round7.js; the earlier scripts are unchanged. Items continue the site's numbering
   (round 8's templates and stylesheet are items 56-60).
   61) Focus containment for the modal dialogs the theme marks aria-modal="true" but does not fully contain:
       the collection Filter drawer, the product Quick view, the mobile navigation drawer and the theme's other
       modals. The theme's own trap wraps Tab forward from the last control, but not Shift+Tab from the freshly
       focused dialog container, and its list of controls is fixed when the dialog opens, so it goes stale when
       a filter group collapses. Result: focus walked out behind an open dialog (reported by an outside retest
       on 2026-11-04 as NG-01 and NG-02; reproduced with real key presses). The list of controls is now worked
       out at each Tab press from what is on screen (an opacity-0 native checkbox under a styled box counts,
       as it does for the keyboard), Shift+Tab from the container or the first control goes to
       the last control, Tab from the last control goes to the first, and a Tab pressed while focus is outside
       an open dialog brings it back inside. The cart drawer (round 1) and the image lightbox (round 7)
       already contain focus and are left alone. (WCAG 2.4.3; ARIA APG modal dialog pattern)
   62) Quick view opens on the first keyboard activation. The theme fetches a product's Quick view content the
       first time its card receives focus or the pointer, and only then wires the button (the empty
       QuickShopHolder for the product is filled at that moment); an Enter that arrives before the fetch
       finishes does nothing, and the
       customer has to press again. A press on a not-yet-ready button now waits for the content and opens the
       dialog, or goes to the product page if the content has not arrived after five seconds. (WCAG 2.1.1)
*/
(function () {
  'use strict';

  var LEAVE_ALONE = '#CartDrawer, .pswp';

  function visible(el) {
    if (!el || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }

  function focusables(root) {
    var nodes = root.querySelectorAll('a[href], area[href], button, input, select, textarea, iframe, [tabindex], [contenteditable="true"]');
    return Array.prototype.filter.call(nodes, function (el) {
      if (el.disabled || el.getAttribute('tabindex') === '-1' || el.getAttribute('aria-hidden') === 'true') return false;
      if (el.closest('[inert], [aria-hidden="true"]')) return false;
      return visible(el);
    });
  }

  /* Dialogs that are open on screen right now, innermost last */
  function openDialogs() {
    var all = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
    return Array.prototype.filter.call(all, function (m) {
      if (m.matches(LEAVE_ALONE)) return false;
      if (m.getAttribute('aria-hidden') === 'true') return false;
      if (m.classList.contains('modal') && !m.classList.contains('modal--is-active')) return false;
      if (window.getComputedStyle(m).opacity === '0') return false; /* mid-way through a closing animation */
      return visible(m);
    });
  }

  /* --- 61) Keep sequential focus inside an open modal dialog --- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || e.defaultPrevented) return;
    var dialogs = openDialogs();
    if (!dialogs.length) return;
    var active = document.activeElement;
    var dialog = null;
    for (var i = dialogs.length - 1; i >= 0; i--) {
      if (dialogs[i].contains(active)) { dialog = dialogs[i]; break; }
    }
    if (!dialog) dialog = dialogs[dialogs.length - 1];
    var list = focusables(dialog);
    if (!list.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      try { dialog.focus(); } catch (err) {}
      return;
    }
    var first = list[0];
    var last = list[list.length - 1];
    var idx = list.indexOf(active);
    if (!dialog.contains(active)) {
      /* focus has escaped (or never arrived): bring it back inside */
      e.preventDefault();
      e.stopImmediatePropagation();
      (e.shiftKey ? last : first).focus();
      return;
    }
    if (e.shiftKey && idx <= 0) {
      /* Shift+Tab from the first control, or from the dialog container itself */
      e.preventDefault();
      e.stopImmediatePropagation();
      last.focus();
    } else if (!e.shiftKey && idx === list.length - 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      first.focus();
    }
  }, true);

  /* --- 62) Quick view: a press on a not-yet-ready button waits for the content, then opens it --- */
  /* The theme renders an empty QuickShopModal/QuickShopHolder pair for every card up front; the holder is
     filled, and the button wired, only when the product's modal content has been fetched. */
  function ready(btn) {
    if (btn.classList.contains('btn--not-ready')) return false;
    var card = btn.closest('.grid-product');
    var handle = card ? card.getAttribute('data-product-handle') : null;
    var holder = handle ? document.getElementById('QuickShopHolder-' + handle) : null;
    return !holder || holder.children.length > 0;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.quick-product__btn') : null;
    if (!btn || ready(btn) || btn.a11yPending) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var card = btn.closest('.grid-product');
    var handle = card ? card.getAttribute('data-product-handle') : null;
    var started = Date.now();
    btn.a11yPending = true;
    btn.setAttribute('aria-busy', 'true');
    (function poll() {
      if (ready(btn)) {
        btn.a11yPending = false;
        btn.removeAttribute('aria-busy');
        btn.click();
        return;
      }
      if (Date.now() - started > 5000) {
        btn.a11yPending = false;
        btn.removeAttribute('aria-busy');
        if (handle) {
          var home = (window.theme && theme.routes && theme.routes.home) ? theme.routes.home : '/';
          window.location.href = home.replace(/\/$/, '') + '/products/' + handle;
        }
        return;
      }
      window.setTimeout(poll, 50);
    })();
  }, true);
})();
